<template>
  <!-- default screen -->
  <div v-if="!displayFilters" class="annuaire-asso flex-column d-flex">
    <header
      class="flex-column justify-content-between flex-nowrap align-item-stretch"
      role="banner"
      id="banner"
      tabindex="-1"
    >
      <search-bar />
      <div class="btn-group d-flex justify-content-between align-items-center">
        <p class="resultat-search-mobile">
          <strong>{{ totalRows }}</strong>
          {{ totalRows > 1 ? i18n.results : i18n.result }}
        </p>
        <button
          v-if="categoriesShown"
          id="toggle-filters"
          class="btn btn-link flex-grow-0"
          type="button"
          @click="toggleFilters"
        >
          <i class="fa fa-plus-circle" aria-hidden="true"></i>
          &nbsp;{{ i18n.filter }}
        </button>
      </div>
    </header>
    <div id="page-container" ref="page-container" class="page-container d-flex flex-column" @scroll="onScroll">
      <main class="row m-0 align-item-stretch align-content-stretch flex-wrap flex-column" id="main" role="main">
        <list-vignette :display-total-results="false" :isScrollBtnShown="isScrollBtnShown" class="col-md-12" />
      </main>
    </div>
  </div>

  <!-- search filter screen -->
  <div v-else class="annuaire-asso flex-column d-flex mobile slide-in-left">
    <div class="modal-dialog">
      <div class="modal-content align-item-stretch align-content-stretch flex-nowrap flex-colum" role="main" id="main">
        <header class="modal-header" role="banner" id="banner">
          <h1 class="modal-title">
            <i class="fa fa-search" aria-hidden="true"></i>
            &nbsp;{{ i18n.research }}
          </h1>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            :aria-label="i18n.abortSearch"
            @click="toggleFilters"
          >
            <span aria-hidden="true">×</span>
          </button>
        </header>
        <div class="page-container d-flex flex-column">
          <main
            class="col-md-12 modal-body d-flex align-item-stretch align-content-stretch flex-wrap flex-colum flex-grow-1"
            role="main"
            id="main"
          >
            <list-categorie
              class="col-md-12"
              :multi="false"
              :show-search-button="true"
              @searchButtonClicked="toggleFilters"
              :display-mobile="true"
            />
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from '@/components/search-bar/SearchBar.vue';
import ListVignette from '@/components/list-vignette/ListVignette.vue';
import ListCategorie from '@/components/list-categorie/ListCategorie.vue';

export default {
  components: {
    SearchBar,
    ListVignette,
    ListCategorie,
  },
  data: function() {
    return {
      i18n: {
        abortSearch: this.$t('abortSearch'),
        filter: this.$t('filter'),
        openInNewTab: this.$t('openInNewTab'),
        research: this.$t('research'),
        resetFilters: this.$t('resetFilters'),
        result: this.$t('result'),
        results: this.$t('results'),
        resultsFound: this.$t('resultsFound'),
      },
      displayFilters: false,
      isScrollBtnShown: false,
    };
  },
  computed: {
    totalRows() {
      return this.$store.state.total;
    },
    // at least one categorie should be visible to display them
    categoriesShown() {
      return this.$store.state.categories.some((category) => this.$route.query[`${category}Hidden`] !== 'true');
    },
  },
  methods: {
    toggleFilters() {
      this.displayFilters = !this.displayFilters;
    },
    onScroll() {
      const node = this.$refs['page-container'];
      const position = node.scrollTop / (node.scrollHeight - node.clientHeight);
      this.isScrollBtnShown = position > 0.05;
    },
  },
  created: function() {
    this.$store.dispatch('search', true);
  },
};
</script>
<style lang="less">
@import url('../assets/styles/layout.less');
@import url('../assets/styles/layout-mobile.less');
@import url('../assets/styles/header.less');
@import url('../assets/styles/searchbar-mobile.less');
@import url('../assets/styles/modal.less');
@import url('../assets/styles/animation.less');
</style>
